export enum ENUM__ml_asset_type {
  // PIPELINE PART | BUNDLE PART | MODEL

  // P | B | M
  BUNDLE = 'BUNDLE',

  /*
   * CONDITIONING
   */

  // _ | _ | M
  CONTROL_NET = 'CONTROL_NET',

  // _ | _ | M
  T2I_ADAPTER = 'T2I_ADAPTER',

  // _ | _ | M
  IP_ADAPTER = 'IP_ADAPTER',

  /*
   * FINE-TUNING/WEIGHT MODIFICATION
   */

  // _ | _ | M
  LORA = 'LORA',

  // _ | _ | M
  EMBEDDING = 'EMBEDDING',

  /*
   * PROCESSING
   */
  // P | _ | M
  IMAGE_ENCODER = 'IMAGE_ENCODER',

  // P | _ | M
  SAFETY_CHECKER = 'SAFETY_CHECKER',

  // P | _ | _
  SCHEDULER_CONFIG = 'SCHEDULER_CONFIG',

  // P | B | M
  TEXT_ENCODER = 'TEXT_ENCODER',

  // P | _ | _
  TOKENIZER = 'TOKENIZER',

  // P | B | M
  VAE = 'VAE',

  // P | B | M
  UNET = 'UNET',

  /*
   * VISION
   */

  VISION = 'VISION',
}

export function is_ml_asset_pipeline(type: ENUM__ml_asset_type) {
  let out_list = [
    ENUM__ml_asset_type.IMAGE_ENCODER,
    ENUM__ml_asset_type.SAFETY_CHECKER,
    ENUM__ml_asset_type.SCHEDULER_CONFIG,
    ENUM__ml_asset_type.TEXT_ENCODER,
    ENUM__ml_asset_type.TOKENIZER,
    ENUM__ml_asset_type.VAE,
    ENUM__ml_asset_type.UNET,
  ];

  return out_list.includes(type);
}
